import { Component } from '@angular/core';
import { CommunicationService } from './../../shared/services/communication.service';
import { ApiService } from './../../shared/services/api.service';
import { ListBase } from './../../shared/components/base/list/list.base.component';
import { OfficeContact } from '../../models/office-contacts/office-contacts.model';

@Component({
    selector: 'swb-office-contact-list',
    templateUrl: './../../shared/components/base/list/list.base.component.html'
})
export class OfficeContactListComponent extends ListBase<OfficeContact> {
    public url = 'office-contacts';
    public routePrefix = 'office-contacts';

    protected hasPagination = false;

    constructor(
        _apiService: ApiService,
        _communicationService: CommunicationService
    ) {
        super(
            _apiService,
            _communicationService
        );
    }

    public getTitle(titleObject: any): string {
        return `<em class="lang-badge">${titleObject.lang}</em> ${titleObject.person} (${titleObject.title})`;
    }
}
